import classNames from "classnames";

import styles from "./Tag.module.css";

type Props = {
  children: JSX.Element[] | JSX.Element | string;
};

export const Tag = ({ children }: Props) => {
  const tagClass = classNames(styles.tag);

  // Tag
  return <div className={tagClass}>{children}</div>;
};
